
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonService } from '../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormsModule } from '@angular/forms';
import { ComboService } from '../../Model/Combo/combo.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { Location } from '@angular/common';
import { LetterDocumentService } from '../../Model/LetterDocument/letter-document.service';
import { BackgroundVerificationService } from '../../Model/BackgroundVerification/background-verification.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-register-detail',
  standalone: true,
  imports: [CommonModule, NgbModule, FormsModule, RouterModule, LoaderComponent],
  templateUrl: './register-detail.component.html',
  styleUrl: './register-detail.component.scss'
})
export class RegisterDetailComponent {
  isDisabled: boolean = false;
  isDisabledG: boolean = false;
  addonURL1 = '';
  addonURL2 = '';
  IsEditable = false;
  buypassbgv = true;
  user = [] as any;
  EmpDependentsTypeOfProofs = [] as any;
  addressTypes = [{ AddressID: 1, Address: 'Local Address' }, { AddressID: 2, Address: 'Native Address' }
    , { AddressID: 3, Address: 'Place Of Birth' }, { AddressID: 4, Address: 'Emergency Contact' }];
  filter = {
    EmpMasterId: 0,
    IsDraft: true as any,
    IsSendForApproval: false,
    EmpStatus: null as any,
  }

  BGVCompulsoryField = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};

  VerificationStatus = {
    AADHAARCardVerificationEnabled: false,
    BankDetailsVerificationEnabled: null,
    CompulsoryAADHAARKYCVerification: null,
    CompulsoryBANKVerification: null,
    CompulsoryPANVerification: null,
    PANCardVerificationEnabled: null,
    CompulsoryMobileVerification: null,
    CompulsoryEmailVerification: null,
  };

  EmployeeDetail = {
    Verification: {
      EmpMasterId: 0,//
      AADHAARVerificationID: 0 as any,//
      AadharVerificationStatus: "Not Verified",//
      PaymentMode: null,//
      NameAsPerAadhaar: null,//
      AadharNo: null,//
      AadharNoKyc: null,//
      AadharAttachment: null,//
      AadharAttachmenturl: null as any,
      Gender: null,//
      LocalAddress1: null,//
      LocalAddress2: null,//
      BirthDate: null,//
      photo: null,//
      photourl: null as any,
      PANVerificationID: 0 as any,//
      PANVerificationStatus: "Not Verified",//
      NameAsPerPAN: null,//
      PANNo: null,//
      PANAttachment: null,//
      PANAttachmenturl: null as any,
      BankVerificationID: 0 as any,//
      BankVerificationStatus: "Not Verified",//
      BankId: null,//
      BankAccountNo: null,//
      IFSCode: null,//
      NameAsPerBank: null,//
      BankAttachment: null,//
      BankAttachmenturl: null as any,
      MobileVerificationStatus: "Not Verified",
      EmailVerificationStatus: "Not Verified"
    },
    BasicInformation: {
      BranchID: null,
      BranchName: null,
      EmpCode: null,
      OldEmpCode: null,
      RegistrationDate: null,
      JoiningDate: null,
      photo: null,
      photourl: null as any,
      NameAsPerAadhar: null,
      firstName: null,
      middleName: null,
      lastName: null,
      EmpName: null,
      PreviousName: null,
      FatherName: null,
      MotherName: null,
      GenderId: null,
      CasteId: null,
      CasteName: null,//
      ReligionId: null,
      ReligionName: null,//
      NationalityId: null,
      NationalityName: null,//
      MotherTongueId: null,
      MotherTongueName: null,//
      ContactNo1: null,
      ContactNo2: null,
      PersonalEmail: null,
      OfficialEmail: null,
      MonthlySalaryExpected: null,
      GradeId: null,
      GenderName: null,//
      GradeName: null,//
      DepartmentId: null,
      DepartmentName: null,//
      SalaryStructureId: null,
      SalaryStructureName: null,//
      //ProbationDate: null as any,
      BirthDate: null as any,
      Age: null,
      RetirementDate: null,
      ContractStartDate: null,
      ContractEndDate: null,
      IsSmartPhoneUser: false,
      ReportingManager1: null,
      ReportingManager2: null,
      PresentStatusId: null,
      PresentStatus: null,//
      StatusDate: null,
      EmpServiceTypeId: null,
      EmpServiceTypeName: null,//
      ShiftId: null,
      ClientId: null,
      SiteId: null,
      SiteName: null,//
      DesignationId: null,
      DesignationName: null,//
      DutyId: null,
      DutyName: null,//
      ClientGroupName: null,
      ShiftTitle: null,
      IsTempEmployee: null,
      ESS_EmpServiceTypeId: null,
      EmpServiceTypeCode: null,
      EmployeeServiceTypeName: null,
      RelieverFlag: false,
      OldERPDesignation: null,
      ClientEmpCode: null,
      BillabilityStatus: null,
      WorkLocationCode: null as any,//new add on 30-mar-2026,
      WorkLocationName: null as any,//new add on 30-mar-2026,
      IsZingHrEntry: false as any,//new add on 01-apr-2026,
      //ResourceId: null,//new add on 12-may-2026,
      PensionDeduction: false as any,//new add on 20-may-2026,
    },
    AdditionalInformation: {
      IdenficationMark1: null,
      IdenficationMark2: null,
      PhysicalDisability: null,
      BloodGroup: null,
      BloodGroupName: null,
      Height: null,
      Weight: null,
      ChestSize: null,
      ColourofEyes: null,
      ColourofEyes_Name: null,//
      ColourofHair: null,
      ColourofHair_Name: null,//
      UniformSize: null,
      UniformSizeName: null,//
      ShoesSize: null,
      ShoesSizeName: null,//
      MartialStatus: null,
      MaritalStatusName: null,//
      NoofChildren: null,
      NoofDependents: null,
      SpouseName: null,
      SpouseBirthDate: null,
      SpouseAge: null,
      Ess_Qual: [] as any,
      Ess_Lang: [] as any,
      QualificationAttachment: null,
      QualificationAttachmenturl: null as any,
      DegreeAttachment: null,
      DegreeAttachmenturl: null as any,
      MetroCity: null,
      AutoTDS: null,
      PhysicalDisabilityCertificate: null,//new add on 12-may-2026,
      PhysicalDisabilityCertificateURL: null as any//new add on 12-may-2026,
    },
    AddressTab: {
      LocalAddress: [{
        LocalAddress1: null,
        LocalAddress2: null,
        LocalCity: null,
        LocalStateId: null,
        StateName: null,//
        LocalDistrictId: null,
        DistrictName: null,//
        LocalTalukaTehsilId: null,
        TalukaName: null,//
        LocalPincode: null,
        LocalPoliceStation: null,
        LocalPostOffice: null,
        LocalDateResiding: null,
        LocalPropertyOwned: null,
      }],
      Attachment: null,
      Attachmenturl: null as any,
      NativeAddress: [{
        NativeAddress1: null,
        NativeAddress2: null,
        NativeCity: null,
        NativeStateId: null,
        StateName: null,
        NativeDistrictId: null,
        DistrictName: null,
        NativeTalukaTehsilId: null,
        TalukaName: null,
        NativePincode: null,
        NativePoliceStation: null,
        NativePostOffice: null,
        NativeContactPersonName: null,
        NativeContactPersonNo: null,
        NativePropertyOwned: null,
      }],
      PlaceofBirth: [{
        PlaceOfBirthAddress1: null,
        PlaceOfBirthAddress2: null,
        PlaceOfBirthCity: null,
        PlaceOfBirthStateId: null,
        StateName: null,//
        PlaceOfBirthDistrictId: null,
        DistrictName: null,//
        PlaceOfBirthTalukaTehsilId: null,
        TalukaName: null,//
        PlaceOfBirthPincode: null,
      }],
      EmergencyContact: [{
        ContactName: null,
        ContactNumber: null,
        ContactRelationShipId: null,
        //RelationshipName: null,//
        ContactAddress1: null,
        ContactAddress2: null,
        ContactCity: null,
        StateId: null,
        //StateName: null,//
        DistrictId: null,
        //DistrictName: null,//
        TalukaTehsilId: null,
        //TalukaName: null,//
        Pincode: null
      }],
      EmergencyContactStateDetails: [{
        RelationshipNameId: null,
        RelationshipName: null,
        StateNameId: null,
        StateName: null,
        DistrictNameId: null,
        DistrictName: null,
        TalukaNameId: null,
        TalukaName: null,
      }],
    },
    EmpNomineeESIC: {
      EmpPFNomineeDetails: [
        {
          EmpPFNominee: null,
          NomineeAddress1: null as any,
          NomineeAddress2: null as any,
          NomineeRelationshipId: null,
          RelationshipName: null,//
          NomineeVillageCity: null as any,
          NomineeStateId: null as any,
          StateName: null,//
          NomineeDistrictId: null as any,
          DistrictName: null,//
          NomineeTalukaTehsilId: null as any,
          TalukaName: null,//
          NomineePinCode: null as any,
          NomineeBirthDate: null as any,
          NomineeShare: null,
          Minor: false as any,
          MinorNomineeGuardian: null,
          NomineeAddressTypeId: null,
          AddressTypeMasterId: null,
          AddressType: null,
          ContactNo: null,
        }
      ],
      EmpDependentDetails: [
        // {
        //   Name: null,//
        //   Address: null,//
        //   DateOfBirth: null as any,//
        //   Relationship: null,//
        //   DocumentMasterId: null,//
        //   DocumentNo: null,//
        //   DocumentAttachment: null,//
        //   DocumentAttachmenturl: null as any,
        // }
      ] as any,
    },
    OtherDetails: {
      ReferenceDetails: [{
        Name: null,
        Address1: null,
        Address2: null,
        VillageCity: null,
        StateId: null,
        StateName: null,
        DistrictId: null,
        DistrictName: null,
        TalukaTehsilId: null,
        TalukaName: null,
        PinCode: null,
        ContactNo: null,
        AddressTypeMasterId: null,
      }],
      Witness: [{
        Name: null,
        Address1: null,
        Address2: null,
        VillageCity: null,
        StateId: null,
        StateName: null,//
        DistrictId: null,
        DistrictName: null,//
        TalukaTehsilId: null,
        TalukaName: null,//
        PinCode: null,
        ContactNo: null,
        AddressTypeMasterId: null,
      }],
      PreviousEmploymentdetails: [{
        Name: null,
        Address: null,
        Position: null,
        FromDate: null,
        ToDate: null,
        EmployerPFNo: null,
        EmployerESICNo: null,
        TotalSalaryDrawn: null,
        ReasonOfLeaving: null,
        Attachment: null,
        Attachmenturl: null,
        RelievingLetter: null,
        RelievingLetterurl: null,
        OfferLetter: null,
        OfferLetterurl: null,
        Payslip: null,
        Payslipurl: null,
      }],
      Referraldetails: [{
        ReferralSource: null,
        ReferralSourceCategory: null,
        ReferredBy: null,
        ReferrerCode: null,
        ReferrerName: null,
      }],
    },
    AccountLicencesTab: {
      PaymentMode: null,
      BankId: null,
      BankName: null,
      IFSCode: null,
      Accountno: null,
      NameAsPerBank: null,
      BankAttachment: null,
      BankAttachmenturl: null,
      ReferenceNumber: null,
      BankVerificationStatus: null,
      AadhaarNo: null,
      AadharAttachment: null,
      AadharAttachmenturl: null,
      AadharVerificationStatus: null,
      PANNo: null,
      PANAttachment: null,
      PANAttachmenturl: null,
      PANVerificationStatus: null,
      ExistingMemberOfESIC: null,
      ESICNo: null,
      ExistingMemberOfPF: null,
      PFNo: null,
      UANNo: null,
      PFStatutoryDeduction: null,
      LINNo: null,
      HoldingGun: null,
      //TypeofGunId: null,
      TypeOfGunId: null,
      TypeofGunName: null,//
      GunLicenseNo: null,
      GunNo: null,
      IssuingAuthority: null,
      DateOfIssue: null,
      DateOfExpiry: null,
      GunRegistrationDate: null,
      GunAttachment: null,
      GunAttachmenturl: null as any,
      HoldingDrivingLicense: null,
      DrivingLicenseNumber: null,
      DrivingLicenseIssueDate: null,
      DrivingLicenseExpiryDate: null,
      DrivingLicenseIssuingAuthority: null,
      DrivingAttachment: null,
      DrivingAttachmenturl: null as any,
    },
    ImageDocumnetTab: {
      Photo: null,
      Photourl: null as any,
      Signature: null,
      Signatureurl: null as any,
      LH1: null,
      LH1url: null as any,
      LH2: null,
      LH2url: null as any,
      LH3: null,
      LH3url: null as any,
      LH4: null,
      LH4url: null as any,
      LH5: null,
      LH5url: null as any,
      RH1: null,
      RH1url: null as any,
      RH2: null,
      RH2url: null as any,
      RH3: null,
      RH3url: null as any,
      RH4: null,
      RH4url: null as any,
      RH5: null,
      RH5url: null as any,
      InterviewingOfficer: null,
      AppointingAuthority: null,
      RecommendedBy1: null,
      RecommendedBy2: null,
      Remark: null,
      EmpDocumentAttachment: [] as any,
    },
    employeeInfo: {
      EmpMasterId: 0,
      EmpTempCode: null,
      FirstName: null as any,
      EmailId: null as any,
      MobileNo: null as any,
      RegistrationType: null as any,
      EmpType: null as any,
      EmailIdShow: null as any,
      MobileNoShow: null as any,
      IsShow: true,
      BGVStatus: null as any,
      ColourCode: null as any,
      FontColor: null as any,
      VerificationMode: null as any,
    }
  }

  LetterData = [];
  bgvCheck = true;
  bgvHistory = [] as any;
  bgvHistoryHeader = [] as any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private employeeRegistration: EmployeeRegistrationService,
    private toast: ToastService,
    private session: SessionService,
    public common: CommonService,
    private combo: ComboService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private location: Location,
    private letterDocument: LetterDocumentService,
    private backgroundVerification: BackgroundVerificationService,
  ) {
    this.user = this.session.GetUserDetails();
    if (this.user.IsPreOnBoarding) {
      this.common.PageRight = {
        IsView: true,
        IsAdd: true,
        IsEdit: true,
        IsDelete: true,
        IsPrint: true,
      }
    } else {
      this.common.getPageRights();
    }
    this.route.params.subscribe(params => this.filter.EmpMasterId = parseInt(params['id']));
    this.route.params.subscribe(params => this.filter.IsDraft = params['draft']);
    this.addonURL1 = this.router.url.split('/')[1];
    this.addonURL2 = this.router.url.split('/')[2];

    this.dtoptions = { ...this.common.commonDToptions };
    this.dtoptions.paging = false;
    this.dtoptions.ordering = false;
  }

  async ngOnInit(): Promise<void> {
    this.filter.IsDraft = (this.filter.IsDraft == "true") ? true : false
    if (this.filter.EmpMasterId > 0) {
      this.ESS_EmpBgvMandatoryDataLoad();
      this.ComboLoad('document');
      await new Promise(f => setTimeout(f, 1000));
      this.GetData('View');

      //if (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable) {
      this.ESS_EmpBgvMandatoryDataLoad();
      this.ESS_EmpBGVVerificationDetailsSelect();
      this.GetAadharPanBankCompulsory();
      //}
    } else {
      this.router.navigate(['/onboarding/register/front']);
    }

    if (this.user.IsPreOnBoarding) {
      this.GetDataPreonboarding();
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetData(TabName: string) {
    this.isDisabledG = true;
    this.employeeRegistration.GetData({ 'SelectType': TabName, 'EmpMasterId': this.filter.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (!response.hasOwnProperty("Error_Code")) {
          this.EmployeeDetail = response;

          if (this.EmployeeDetail.AddressTab.EmergencyContactStateDetails.length == 0) {
            this.EmployeeDetail.AddressTab.EmergencyContactStateDetails.push({
              RelationshipNameId: null,
              RelationshipName: null,
              StateNameId: null,
              StateName: null,
              DistrictNameId: null,
              DistrictName: null,
              TalukaNameId: null,
              TalukaName: null,
            });
          }
          if (this.EmployeeDetail.Verification.photo != null && this.EmployeeDetail.Verification.photo != "") {
            this.EmployeeDetail.Verification.photourl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhotoFolder + '/' + this.EmployeeDetail.Verification.photo;
          }
          if (this.EmployeeDetail.Verification.AadharAttachment != null && this.EmployeeDetail.Verification.AadharAttachment != "") {
            this.EmployeeDetail.Verification.AadharAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.AadhaarFolder + '/' + this.EmployeeDetail.Verification.AadharAttachment;
          }
          if (this.EmployeeDetail.Verification.PANAttachment != null && this.EmployeeDetail.Verification.PANAttachment != "") {
            this.EmployeeDetail.Verification.PANAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PanFolder + '/' + this.EmployeeDetail.Verification.PANAttachment;
          }
          if (this.EmployeeDetail.Verification.BankAttachment != null && this.EmployeeDetail.Verification.BankAttachment != "") {
            this.EmployeeDetail.Verification.BankAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.BankDetailsFolder + '/' + this.EmployeeDetail.Verification.BankAttachment;
          }

          if (this.EmployeeDetail.BasicInformation.photo != null && this.EmployeeDetail.Verification.photo != "") {
            this.EmployeeDetail.BasicInformation.photourl = this.EmployeeDetail.BasicInformation.photourl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhotoFolder + '/' + this.EmployeeDetail.BasicInformation.photo;
          }

          if (this.EmployeeDetail.AdditionalInformation.Ess_Lang.length > 0) {
            if (this.EmployeeDetail.AdditionalInformation.Ess_Lang[0].LanguageID == 0 || this.EmployeeDetail.AdditionalInformation.Ess_Lang[0].LanguageID == "" || this.EmployeeDetail.AdditionalInformation.Ess_Lang[0].LanguageID == null) {
              this.EmployeeDetail.AdditionalInformation.Ess_Lang = []
            }
          }

          if (this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0) {
            if (this.EmployeeDetail.AdditionalInformation.Ess_Qual[0].QualificationId == 0 || this.EmployeeDetail.AdditionalInformation.Ess_Qual[0].QualificationId == "" || this.EmployeeDetail.AdditionalInformation.Ess_Qual[0].QualificationId == null) {
              this.EmployeeDetail.AdditionalInformation.Ess_Qual = []
            }
          }

          this.EmployeeDetail.AdditionalInformation.Ess_Lang.forEach((element: any) => {
            element.Read = this.common.ToLowerCase(element.Read) == 'true' ? true : false;
            element.Write = this.common.ToLowerCase(element.Write) == 'true' ? true : false;
            element.Speak = this.common.ToLowerCase(element.Speak) == 'true' ? true : false;
          });

          if (this.EmployeeDetail.AdditionalInformation.PhysicalDisabilityCertificate != null && this.EmployeeDetail.AdditionalInformation.PhysicalDisabilityCertificate != "") {
            this.EmployeeDetail.AdditionalInformation.PhysicalDisabilityCertificateURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhysicalDisabilityAttachmentFolder + '/' + this.EmployeeDetail.AdditionalInformation.PhysicalDisabilityCertificate;
          }

          if (this.EmployeeDetail.AdditionalInformation.QualificationAttachment != null && this.EmployeeDetail.AdditionalInformation.QualificationAttachment != "") {
            this.EmployeeDetail.AdditionalInformation.QualificationAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.QualificationFolder + '/' + this.EmployeeDetail.AdditionalInformation.QualificationAttachment;
          }

          if (this.EmployeeDetail.AdditionalInformation.DegreeAttachment != null && this.EmployeeDetail.AdditionalInformation.DegreeAttachment != "") {
            this.EmployeeDetail.AdditionalInformation.DegreeAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.DegreeAttachment + '/' + this.EmployeeDetail.AdditionalInformation.DegreeAttachment;
          }

          if (this.EmployeeDetail.AddressTab.Attachment != null && this.EmployeeDetail.AddressTab.Attachment != "") {
            this.EmployeeDetail.AddressTab.Attachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.AddressFolder + '/' + this.EmployeeDetail.AddressTab.Attachment;
          }

          this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.forEach((element: any) => {
            if (element.Attachment != null && element.Attachment != "") {
              element.Attachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PreviousEmployment + '/' + element.Attachment;
            }
            if (element.RelievingLetter != null && element.RelievingLetter != "") {
              element.RelievingLetterurl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PreviousEmployment + '/' + element.RelievingLetter;
            }
            if (element.OfferLetter != null && element.OfferLetter != "") {
              element.OfferLetterurl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PreviousEmployment + '/' + element.OfferLetter;
            }
            if (element.Payslip != null && element.Payslip != "") {
              element.Payslipurl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PreviousEmployment + '/' + element.Payslip;
            }
          });

          this.EmployeeDetail.EmpNomineeESIC.EmpDependentDetails.forEach((element: any) => {
            if (element.DocumentMasterId != null && element.DocumentAttachment != null && element.DocumentAttachment != "") {
              element.DocumentAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == element.DocumentMasterId)[0].Document + '/' + element.DocumentAttachment;
            }
          });

          if (this.EmployeeDetail.AccountLicencesTab.DrivingAttachment != null && this.EmployeeDetail.AccountLicencesTab.DrivingAttachment != "") {
            this.EmployeeDetail.AccountLicencesTab.DrivingAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.DrivingLicenseFolder + '/' + this.EmployeeDetail.AccountLicencesTab.DrivingAttachment;
          }
          if (this.EmployeeDetail.AccountLicencesTab.GunAttachment != null && this.EmployeeDetail.AccountLicencesTab.GunAttachment != "") {
            this.EmployeeDetail.AccountLicencesTab.GunAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.GunLicenseFolder + '/' + this.EmployeeDetail.AccountLicencesTab.GunAttachment;
          }

          if (this.EmployeeDetail.ImageDocumnetTab.Photo != null && this.EmployeeDetail.ImageDocumnetTab.Photo != "") {
            this.EmployeeDetail.ImageDocumnetTab.Photourl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhotoFolder + '/' + '/' + this.EmployeeDetail.ImageDocumnetTab.Photo;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.Signature != null && this.EmployeeDetail.ImageDocumnetTab.Signature != "") {
            this.EmployeeDetail.ImageDocumnetTab.Signatureurl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.SignatureFolder + '/' + '/' + this.EmployeeDetail.ImageDocumnetTab.Signature;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.LH1 != null && this.EmployeeDetail.ImageDocumnetTab.LH1 != "") {
            this.EmployeeDetail.ImageDocumnetTab.LH1url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH1Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.LH1;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.LH2 != null && this.EmployeeDetail.ImageDocumnetTab.LH2 != "") {
            this.EmployeeDetail.ImageDocumnetTab.LH2url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH2Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.LH2;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.LH3 != null && this.EmployeeDetail.ImageDocumnetTab.LH3 != "") {
            this.EmployeeDetail.ImageDocumnetTab.LH3url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH3Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.LH3;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.LH4 != null && this.EmployeeDetail.ImageDocumnetTab.LH4 != "") {
            this.EmployeeDetail.ImageDocumnetTab.LH4url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH4Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.LH4;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.LH5 != null && this.EmployeeDetail.ImageDocumnetTab.LH5 != "") {
            this.EmployeeDetail.ImageDocumnetTab.LH5url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH5Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.LH5;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.RH1 != null && this.EmployeeDetail.ImageDocumnetTab.RH1 != "") {
            this.EmployeeDetail.ImageDocumnetTab.RH1url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH1Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.RH1;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.RH2 != null && this.EmployeeDetail.ImageDocumnetTab.RH2 != "") {
            this.EmployeeDetail.ImageDocumnetTab.RH2url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH2Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.RH2;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.RH3 != null && this.EmployeeDetail.ImageDocumnetTab.RH3 != "") {
            this.EmployeeDetail.ImageDocumnetTab.RH3url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH3Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.RH3;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.RH4 != null && this.EmployeeDetail.ImageDocumnetTab.RH4 != "") {
            this.EmployeeDetail.ImageDocumnetTab.RH4url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH4Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.RH4;
          }
          if (this.EmployeeDetail.ImageDocumnetTab.RH5 != null && this.EmployeeDetail.ImageDocumnetTab.RH5 != "") {
            this.EmployeeDetail.ImageDocumnetTab.RH5url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH5Folder + '/' + this.EmployeeDetail.ImageDocumnetTab.RH5;
          }
          this.EmployeeDetail.ImageDocumnetTab.EmpDocumentAttachment.forEach((element: any) => {
            if (element.Attachment != null && element.Attachment != "") {
              element.Attachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + element.Document + '/' + element.Attachment;
            }
          });

          if (this.EmployeeDetail.EmpNomineeESIC.EmpDependentDetails.length > 0) {
            this.EmployeeDetail.EmpNomineeESIC.EmpDependentDetails.forEach((element: any) => {
              if (element.Address != '' && element.Address != null && element.Address != '0' && parseInt(element.Address) > 0) {
                element.AddressTypeName = this.addressTypes.filter(e => e.AddressID == parseInt(element.Address))[0].Address;
              }
            });
          }

          if (this.common.ToLowerCase(this.EmployeeDetail.employeeInfo.RegistrationType) == 'preonboarding') {
            this.GetDataPreonboarding();
          } else if (this.common.ToLowerCase(this.EmployeeDetail.employeeInfo.RegistrationType) == 'manual' || this.EmployeeDetail.employeeInfo.RegistrationType == null || this.EmployeeDetail.employeeInfo.RegistrationType == '') {
            if (!this.filter.IsDraft || this.common.ToLowerCase(this.filter.IsDraft.toString()) == 'false') {
              this.GetDataMenual();
            } else {
              this.IsEditable = true;
            }
          } else if (this.common.ToLowerCase(this.EmployeeDetail.employeeInfo.RegistrationType) == 'mobile registration' && (!this.filter.IsDraft || this.common.ToLowerCase(this.filter.IsDraft.toString()) == 'false')) {
            this.IsEditable = true;
            this.GetDataMenual();
          }

          if (!this.EmployeeDetail.BasicInformation.IsTempEmployee) {
            this.ESS_EmployeeLetterDetailsLoad();
          }
          this.ESSEmpOnlineRegistrationRejectSelect();
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
        }
        this.showFooterMasking();
        this.isDisabledG = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabledG = false;
      },
    });
  }

  async FinalSubmit() {
    if (this.VerificationStatus.CompulsoryAADHAARKYCVerification && (this.EmployeeDetail.Verification.AADHAARVerificationID == 0 || this.EmployeeDetail.Verification.AADHAARVerificationID == null || this.EmployeeDetail.Verification.AADHAARVerificationID == '')) {
      this.toast.show({ message: 'Please verify aadhar card.', type: toastTypeEnum.warning });
    } else if (this.VerificationStatus.CompulsoryPANVerification && (this.EmployeeDetail.Verification.PANVerificationID == 0 || this.EmployeeDetail.Verification.PANVerificationID == null || this.EmployeeDetail.Verification.PANVerificationID == '')) {
      this.toast.show({ message: 'Please verify pan card.', type: toastTypeEnum.warning });
    } else if (this.VerificationStatus.CompulsoryBANKVerification && (this.EmployeeDetail.Verification.BankVerificationID == 0 || this.EmployeeDetail.Verification.BankVerificationID == null || this.EmployeeDetail.Verification.BankVerificationID == '')) {
      this.toast.show({ message: 'Please verify bank account.', type: toastTypeEnum.warning });
    } else if (this.VerificationStatus.CompulsoryMobileVerification && this.common.ToLowerCase(this.EmployeeDetail.Verification.MobileVerificationStatus) != 'verified') {
      this.toast.show({ message: 'Please verify mobile no.', type: toastTypeEnum.warning });
    } else if (this.VerificationStatus.CompulsoryEmailVerification && this.common.ToLowerCase(this.EmployeeDetail.Verification.EmailVerificationStatus) != 'verified') {
      this.toast.show({ message: 'Please verify email id.', type: toastTypeEnum.warning });
    } else {
      if (!this.buypassbgv && this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable) {
        if (this.BGVCompulsoryField.length > 0) {
          this.BGVCompulsoryField.forEach((element: any) => {
            if (element.TabName == "Tab4") {
              if (element.MandatoryField == 'LocalAddress1' && (this.EmployeeDetail.AddressTab.LocalAddress[0].LocalAddress1 == null || this.EmployeeDetail.AddressTab.LocalAddress[0].LocalAddress1 == '')) {
                this.toast.show({ message: "Local Address Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'NativeAddress1' && (this.EmployeeDetail.AddressTab.NativeAddress[0].NativeAddress1 == null || this.EmployeeDetail.AddressTab.NativeAddress[0].NativeAddress1 == '')) {
                this.toast.show({ message: "Native Address Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              }
            } else if (element.TabName == "Tab3") {
              if (element.MandatoryField == 'EnrollmentNumber' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.Ess_Qual.filter((e: any) => e.EnrollmentNumber == null || e.EnrollmentNumber == '').length > 0)) {
                this.toast.show({ message: "Enrollment Number Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'College' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.Ess_Qual.filter((e: any) => e.College == null || e.College == '').length > 0)) {
                this.toast.show({ message: "College Name Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'QualificationName' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.Ess_Qual.filter((e: any) => e.QualificationName == null || e.QualificationName == '').length > 0)) {
                this.toast.show({ message: "Qualification Name Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'UniversityBoard' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.Ess_Qual.filter((e: any) => e.UniversityBoard == null || e.UniversityBoard == '').length > 0)) {
                this.toast.show({ message: "University Board Name Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'CGPA' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.Ess_Qual.filter((e: any) => e.CGPA == null || e.CGPA == '').length > 0)) {
                this.toast.show({ message: "CGPA Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'FromDate' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.Ess_Qual.filter((e: any) => e.FromDate == null || e.FromDate == '').length > 0)) {
                this.toast.show({ message: "From Date Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'ToDate' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.Ess_Qual.filter((e: any) => e.ToDate == null || e.ToDate == '').length > 0)) {
                this.toast.show({ message: "To Date Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'QualificationAttachment' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.QualificationAttachment == null || this.EmployeeDetail.AdditionalInformation.QualificationAttachment == '')) {
                this.toast.show({ message: "Qualification Attachment Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'DegreeAttachment' && this.EmployeeDetail.AdditionalInformation.Ess_Qual.length > 0 && (this.EmployeeDetail.AdditionalInformation.DegreeAttachment == null || this.EmployeeDetail.AdditionalInformation.DegreeAttachment == '')) {
                this.toast.show({ message: "Degree Attachment Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              }
            } else if (element.TabName == "Tab6") {
              if (element.MandatoryField == 'Name' && this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.length > 0 && (this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.filter(e => e.Name == null || e.Name == '').length > 0)) {
                this.toast.show({ message: "Previous Employment Name Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'Position' && this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.length > 0 && (this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.filter(e => e.Position == null || e.Position == '').length > 0)) {
                this.toast.show({ message: "Previous Employment Position Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'RelievingLetter' && this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.length > 0 && this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.filter(e => e.RelievingLetter == null || e.RelievingLetter == '').length > 0) {
                this.toast.show({ message: "Relieving Letter Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'OfferLetter' && this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.length > 0 && this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.filter(e => e.OfferLetter == null || e.OfferLetter == '').length > 0) {
                this.toast.show({ message: "Offer Letter Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              } else if (element.MandatoryField == 'Payslip' && this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.length > 0 && this.EmployeeDetail.OtherDetails.PreviousEmploymentdetails.filter(e => e.Payslip == null || e.Payslip == '').length > 0) {
                this.toast.show({ message: "Payslip Letter Is Mandatory", type: toastTypeEnum.warning });
                this.bgvCheck = false;
              }
            }

            if (!this.bgvCheck) {
              return;
            }
          });
          if (this.bgvCheck) {
            this.EmployeeFinal_BgvSubmit();
          }
        } else {
          this.EmployeeFinal_BgvSubmit();
        }
      } else {
        this.EmployeeFinalSubmit();
      }
    }
  }

  async EmployeeFinalSubmit(IsBgvBuypass = false) {
    await this.common.getPageRights();
    if (this.common.PageRight.IsEdit && this.IsEditable) {
      if (this.VerificationStatus.CompulsoryAADHAARKYCVerification && (this.EmployeeDetail.Verification.AADHAARVerificationID == 0 || this.EmployeeDetail.Verification.AADHAARVerificationID == null || this.EmployeeDetail.Verification.AADHAARVerificationID == '')) {
        this.toast.show({ message: 'Please verify aadhar card.', type: toastTypeEnum.warning });
      } else if (this.VerificationStatus.CompulsoryPANVerification && (this.EmployeeDetail.Verification.PANVerificationID == 0 || this.EmployeeDetail.Verification.PANVerificationID == null || this.EmployeeDetail.Verification.PANVerificationID == '')) {
        this.toast.show({ message: 'Please verify pan card.', type: toastTypeEnum.warning });
      } else if (this.VerificationStatus.CompulsoryBANKVerification && (this.EmployeeDetail.Verification.BankVerificationID == 0 || this.EmployeeDetail.Verification.BankVerificationID == null || this.EmployeeDetail.Verification.BankVerificationID == '')) {
        this.toast.show({ message: 'Please verify bank account.', type: toastTypeEnum.warning });
      } else if (this.VerificationStatus.CompulsoryMobileVerification && this.common.ToLowerCase(this.EmployeeDetail.Verification.MobileVerificationStatus) != 'verified') {
        this.toast.show({ message: 'Please verify mobile no.', type: toastTypeEnum.warning });
      } else if (this.VerificationStatus.CompulsoryEmailVerification && this.common.ToLowerCase(this.EmployeeDetail.Verification.EmailVerificationStatus) != 'verified') {
        this.toast.show({ message: 'Please verify email id.', type: toastTypeEnum.warning });
      } else if ((this.EmployeeDetail.AdditionalInformation.NoofDependents == 0 || this.EmployeeDetail.AdditionalInformation.NoofDependents == '' || this.EmployeeDetail.AdditionalInformation.NoofDependents == null) ||
        (this.EmployeeDetail.AdditionalInformation.NoofDependents > 0 && this.EmployeeDetail.AdditionalInformation.NoofDependents == this.EmployeeDetail.EmpNomineeESIC.EmpDependentDetails.length)) {

        if (this.EmployeeDetail.AccountLicencesTab.AadhaarNo != null && this.EmployeeDetail.AccountLicencesTab.AadhaarNo != '' && (this.EmployeeDetail.AccountLicencesTab.AadharAttachment == null || this.EmployeeDetail.AccountLicencesTab.AadharAttachment == '')) {
          this.toast.show({ message: "Please upload aadhar attachment.", type: toastTypeEnum.warning });
        } else if (this.EmployeeDetail.AccountLicencesTab.PANNo != null && this.EmployeeDetail.AccountLicencesTab.PANNo != '' && (this.EmployeeDetail.AccountLicencesTab.PANAttachment == null || this.EmployeeDetail.AccountLicencesTab.PANAttachment == '')) {
          this.toast.show({ message: "Please upload pan card attachment.", type: toastTypeEnum.warning });
        } else {
          const modalRef = this.modalService.open(ConfirmationComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = IsBgvBuypass ? 'Do you want to bypass.?' : 'Do you want to final save?';
          modalRef.result.then((result: any) => {
            if (result) {
              this.isDisabled = true;
              this.employeeRegistration.EmployeeFinalSubmit({ EmpMasterId: this.filter.EmpMasterId, SelectType: 'I', SelectType1: 'Add', UserMasterId: this.session.GetUserDetails().UserId, TableName: 'EmployeeMaster', IsDraft: this.filter.IsDraft, EmpType: this.EmployeeDetail.employeeInfo.EmpType }).subscribe({
                next: (response) => {
                  if (response.Error_Code == "15") {
                    const modalRef = this.modalService.open(AlertSuccessComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => {
                      if (result) {
                        if (!this.user.IsPreOnBoarding) {
                          if (this.EmployeeDetail.BasicInformation.IsZingHrEntry) {
                            this.router.navigate(['onboarding/zinghr']);
                          } else {
                            if (this.common.ToLowerCase(this.addonURL2) == 'register' || this.common.ToLowerCase(this.addonURL2) == 'preonboarding' || this.common.ToLowerCase(this.addonURL2) == 'candidateinitiation') {
                              this.router.navigate([this.addonURL1 + '/' + this.addonURL2 + '/' + this.common.ToLowerCase(this.EmployeeDetail.employeeInfo.EmpType)]);
                            } else {
                              this.router.navigate([this.addonURL1 + '/' + this.addonURL2 + '/']);
                            }
                          }
                        } else {
                          this.session.End();
                          // this.router.navigate(['preonboarding/detail/' + this.filter.EmpMasterId + '/' + false]);
                          // window.location.reload();
                        }
                      }
                    });
                  } else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                  }
                  this.isDisabled = false;
                },
                complete: () => {
                  this.isDisabled = false;
                },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          });
        }
      } else {
        this.toast.show({ message: "Add " + this.EmployeeDetail.AdditionalInformation.NoofDependents + " esic nominee details .", type: toastTypeEnum.warning });
      }
    } else {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = this.tooltip.Message.UnauthorizedMessage;
      modalRef.result.then((result: any) => { });
    }
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0, clearChild = true) {
    this.isDisabled = true;

    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': 0,
      'ClientId': 0,
      'SiteId': 0,
      'DesignationId': 0,
      'EmpType': '',
      'StateId': 0,
      'DistrictId': 0,
      'EmpMasterID': 0
    }).subscribe({
      next: (response) => {
        if (Combotype == 'document') {
          this.EmpDependentsTypeOfProofs = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESSEmpOnlineRegistrationRejectSelect() {
    this.isDisabled = true;
    this.employeeRegistration.ESSEmpOnlineRegistrationRejectSelect({ EmployeeId: this.EmployeeDetail.employeeInfo.EmpMasterId }).subscribe({
      next: (response) => {
        if (response.Table.filter((e: any) => e.ID == this.EmployeeDetail.employeeInfo.EmpMasterId).length > 0) {
          this.filter.IsSendForApproval = true;
        } else {
          this.filter.IsSendForApproval = false;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  showFooterMasking() {
    if (this.EmployeeDetail.employeeInfo.IsShow == undefined) { this.EmployeeDetail.employeeInfo.IsShow = true }
    this.EmployeeDetail.employeeInfo.IsShow = !this.EmployeeDetail.employeeInfo.IsShow;
    if (this.EmployeeDetail.employeeInfo.IsShow) {
      if (this.EmployeeDetail.employeeInfo.EmailId != null) {
        this.EmployeeDetail.employeeInfo.EmailIdShow = this.EmployeeDetail.employeeInfo.EmailId;
      }
      if (this.EmployeeDetail.employeeInfo.MobileNo != null) {
        this.EmployeeDetail.employeeInfo.MobileNoShow = this.EmployeeDetail.employeeInfo.MobileNo;
      }
    } else {
      if (this.EmployeeDetail.employeeInfo.EmailId != null) {
        this.EmployeeDetail.employeeInfo.EmailIdShow = 'XXXXX@' + this.EmployeeDetail.employeeInfo.EmailId.split('@')[1];
      }
      if (this.EmployeeDetail.employeeInfo.MobileNo != null) {
        this.EmployeeDetail.employeeInfo.MobileNoShow = this.EmployeeDetail.employeeInfo.MobileNo?.substring(0, 4) + 'XXXXXX';
      }
    }
  }

  GetDataPreonboarding() {
    this.employeeRegistration.ESS_EmpRegistration_SearchGet({ 'SelectType': 'PreOnBoarding', 'EmpMasterId': this.filter.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.filter.EmpStatus = response.Table.filter((e: any) => e.EmpMasterId == this.filter.EmpMasterId)[0].Status;
          if (response.Table.filter((e: any) => e.EmpMasterId == this.filter.EmpMasterId && this.common.ToLowerCase(e.Status) != 'finalsubmitted').length > 0) {
            this.IsEditable = true;
          } else {
            this.IsEditable = false;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDataMenual() {
    this.employeeRegistration.ESS_EmpRegistration_SearchGet({ 'SelectType': 'Search', 'EmpMasterId': this.EmployeeDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.filter.EmpStatus = response.Table.filter((e: any) => e.EmpMasterId == this.EmployeeDetail.employeeInfo.EmpMasterId)[0].ApprovalStatus;
          if (response.Table.filter((e: any) => e.EmpMasterId == this.EmployeeDetail.employeeInfo.EmpMasterId && (this.common.ToLowerCase(e.ApprovalStatus) == 'approved' || e.ApprovalStatus == '')).length > 0) {
            this.IsEditable = true;
          } else {
            this.IsEditable = false;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Cancel() {
    if (this.common.ToLowerCase(this.addonURL2) == 'registrationapproval') {
      this.location.back();
    } else if (this.common.ToLowerCase(this.addonURL2) == 'register' || this.common.ToLowerCase(this.addonURL2) == 'preonboarding' || this.common.ToLowerCase(this.addonURL2) == 'candidateinitiation') {
      this.router.navigate([this.addonURL1 + '/' + this.addonURL2 + '/' + this.common.ToLowerCase(this.EmployeeDetail.employeeInfo.EmpType)]);
    } else {
      this.router.navigate([this.addonURL1 + '/' + this.addonURL2 + '/']);
    }
  }

  ESS_EmployeeLetterDetailsLoad() {
    this.isDisabled = true;
    this.letterDocument.ESS_EmployeeLetterDetailsLoad({ SelectType: 'RegistrationLetter', EmpMasterID: this.filter.EmpMasterId }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.LetterData = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpBgvMandatoryDataLoad() {
    this.isDisabled = true;
    this.backgroundVerification.ESS_EmpBgvMandatoryDataLoad({ SelectType: 'S', EmpMasterId: this.filter.EmpMasterId, IsDraft: this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response.Table && response.Table.length > 0 && response.Table1 && response.Table1.length > 0) {
          this.BGVCompulsoryField = response.Table1;
          this.buypassbgv = false;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpBGVVerificationDetailsSelect() {
    this.isDisabled = true;
    this.bgvHistoryHeader = [];
    this.backgroundVerification.ESS_EmpBGVVerificationDetailsSelect({ SelectType: 'S', EmpMasterId: this.filter.EmpMasterId, IsDraft: this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response && response.Table) {
          this.bgvHistory = Object.values(response.Table);
        }

        [...new Set(this.bgvHistory.map((e: any) => e.APIName))].forEach((element: any) => {

          [...new Set(this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic').map((e: any) => e.APIName))].forEach((element: any) => {
            this.bgvHistoryHeader.push({
              ESS_BGVAPIMasterID: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].ESS_BGVAPIMasterID,
              APIName: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].APIName,
              InitiatedBy: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].InitiatedBy,
              InitiatedOn: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].InitiatedOn,
              Data: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic'),
              VerificationMode: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].VerificationMode,
              VerificationType: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].FinalVerificationStatus,
              FinalStatusColourCode: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].FinalStatusColourCode,
              FinalStatusFontColor: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].FinalStatusFontColor,
            })
          });

          const Dates = [...new Set(this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic').map((e: any) => e.Createdon))];

          Dates.forEach((eDate: any) => {
            this.bgvHistoryHeader.push({
              ESS_BGVAPIMasterID: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].ESS_BGVAPIMasterID,
              APIName: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].APIName,
              InitiatedBy: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].InitiatedBy,
              InitiatedOn: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].Createdon,
              Data: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate),
              VerificationMode: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].VerificationMode,
              VerificationType: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].FinalVerificationStatus,
              FinalStatusColourCode: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].FinalStatusColourCode,
              FinalStatusFontColor: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].FinalStatusFontColor,
            })
          });
        });
        // [...new Set(this.bgvHistory.map((e: any) => e.APIName))].forEach((element: any) => {
        //   this.bgvHistoryHeader.push({
        //     ESS_BGVAPIMasterID: this.bgvHistory.filter((e: any) => e.APIName == element)[0].ESS_BGVAPIMasterID,
        //     APIName: this.bgvHistory.filter((e: any) => e.APIName == element)[0].APIName,
        //     InitiatedBy: this.bgvHistory.filter((e: any) => e.APIName == element)[0].InitiatedBy,
        //     InitiatedOn: this.bgvHistory.filter((e: any) => e.APIName == element)[0].InitiatedOn,
        //     Data: this.bgvHistory.filter((e: any) => e.APIName == element),
        //     VerificationType: this.bgvHistory.filter((e: any) => e.APIName == element)[0].FinalVerificationStatus,
        //     FinalStatusColourCode: this.bgvHistory.filter((e: any) => e.APIName == element)[0].FinalStatusColourCode,
        //   });
        // });

        this.bgvHistoryHeader.forEach((element: any) => {
          element.Data.forEach((element2: any) => {
            if (element2.FileName != null && element2.FileName != '') {
              element2.ReportURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.MenualBGVAttachment + '/' + element2.FileName;
            }
          });
        });

        try {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } catch (e) { }

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  toggleRow(i: number, j: number): void {
    if (!this.bgvHistoryHeader[i].Data[j].expanded) {
      this.bgvHistoryHeader[i].Data.map((e: any) => e.expanded = false);
    }
    this.bgvHistoryHeader[i].Data[j].expanded = !this.bgvHistoryHeader[i].Data[j].expanded;
  }

  GetHedername(type: string) {
    switch (this.common.ToLowerCase(type)) {
      case 'eav':
        return 'Employee Address Verification';
      case 'crc':
        return 'Criminal Record Check';
      case 'eqv':
        return 'Employee Qualification Verification';
      case 'ev':
        return 'Employment Verification';
      default:
        return '';
    }
  }

  async EmployeeFinal_BgvSubmit() {
    await this.common.getPageRights();
    if (this.common.PageRight.IsEdit && this.IsEditable) {
      if ((this.EmployeeDetail.AdditionalInformation.NoofDependents == 0 || this.EmployeeDetail.AdditionalInformation.NoofDependents == '' || this.EmployeeDetail.AdditionalInformation.NoofDependents == null) ||
        (this.EmployeeDetail.AdditionalInformation.NoofDependents > 0 && this.EmployeeDetail.AdditionalInformation.NoofDependents == this.EmployeeDetail.EmpNomineeESIC.EmpDependentDetails.length)) {

        if (this.EmployeeDetail.AccountLicencesTab.AadhaarNo != null && this.EmployeeDetail.AccountLicencesTab.AadhaarNo != '' && (this.EmployeeDetail.AccountLicencesTab.AadharAttachment == null || this.EmployeeDetail.AccountLicencesTab.AadharAttachment == '')) {
          this.toast.show({ message: "Please upload aadhar attachment.", type: toastTypeEnum.warning });
        } else if (this.EmployeeDetail.AccountLicencesTab.PANNo != null && this.EmployeeDetail.AccountLicencesTab.PANNo != '' && (this.EmployeeDetail.AccountLicencesTab.PANAttachment == null || this.EmployeeDetail.AccountLicencesTab.PANAttachment == '')) {
          this.toast.show({ message: "Please upload pan card attachment.", type: toastTypeEnum.warning });
        } else {
          const modalRef = this.modalService.open(ConfirmationComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Do you want to send for background verification?';
          modalRef.result.then((result: any) => {
            if (result) {
              this.isDisabled = true;
              this.employeeRegistration.EmployeeFinal_BgvSubmit({ domainName: this.session.GetUserDetails().Domain, EmpMasterId: this.filter.EmpMasterId, SelectType: 'I', SelectType1: 'Add', UserMasterId: this.session.GetUserDetails().UserId, TableName: 'EmployeeMaster', IsDraft: this.filter.IsDraft, EmpType: this.EmployeeDetail.employeeInfo.EmpType }).subscribe({
                next: (response) => {
                  if (response.Error_Code == "200") {
                    const modalRef = this.modalService.open(AlertSuccessComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => {
                      if (result) {
                        if (!this.user.IsPreOnBoarding) {
                          // if (this.EmployeeDetail.BasicInformation.IsZingHrEntry) {
                          //   this.router.navigate(['onboarding/zinghr']);
                          // } else {
                          //   this.GetData('View');
                          //   this.ESS_EmpBgvMandatoryDataLoad();
                          //   this.ESS_EmpBGVVerificationDetailsSelect();
                          // }
                          if (this.EmployeeDetail.BasicInformation.IsZingHrEntry) {
                            this.router.navigate(['onboarding/zinghr']);
                          } else {
                            if (this.common.ToLowerCase(this.addonURL2) == 'register' || this.common.ToLowerCase(this.addonURL2) == 'preonboarding' || this.common.ToLowerCase(this.addonURL2) == 'candidateinitiation') {
                              this.router.navigate([this.addonURL1 + '/' + this.addonURL2 + '/' + this.common.ToLowerCase(this.EmployeeDetail.employeeInfo.EmpType)]);
                            } else {
                              this.router.navigate([this.addonURL1 + '/' + this.addonURL2 + '/']);
                            }
                          }
                        } else {
                          this.session.End();
                          // this.router.navigate(['preonboarding/detail/' + this.filter.EmpMasterId + '/' + false]);
                          // window.location.reload();
                        }
                      }
                    });
                  } else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                  }
                  this.isDisabled = false;
                },
                complete: () => {
                  this.isDisabled = false;
                },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          });
        }
      } else {
        this.toast.show({ message: "Add " + this.EmployeeDetail.AdditionalInformation.NoofDependents + " esic nominee details .", type: toastTypeEnum.warning });
      }
    } else {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = this.tooltip.Message.UnauthorizedMessage;
      modalRef.result.then((result: any) => { });
    }
  }

  GetAadharPanBankCompulsory() {
    this.isDisabled = true;
    if (this.EmployeeDetail.BasicInformation.IsZingHrEntry) {
      //if (false) {
      this.employeeRegistration.ESS_GetCompanyParameterDetailsZingHr({ EmpMasterId: this.EmployeeDetail.employeeInfo.EmpMasterId, IsDraft: this.filter.IsDraft }).subscribe({
        next: (response) => {
          if (response) {
            this.VerificationStatus = response[0];
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.employeeRegistration.GetAadharPanBankCompulsory({}).subscribe({
        next: (response) => {
          if (response) {
            this.VerificationStatus = response;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    }
  }
}
